


















import {
    Component,
    Prop,
    BaseView,
    QAFlowStepsNavigation,
    ComponentStyle,
    ComponentStyleDefinition,
    ComponentConfig,
    Emit, AdvisorNavigation, SectionType
} from "@zoovu/runner-browser-api";
import {isMobile} from "./utils";
import {QuestionConfiguration} from "../configuration";

@Component({})
export default class PageSelectorView extends BaseView {

    @ComponentConfig(QuestionConfiguration)
    componentConfiguration: QuestionConfiguration;

    @Prop()
    navigation: AdvisorNavigation;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @Prop({default: false})
    showHeadline: boolean;

    goTo(stepIndex: number) {
        this.navigation.currentSection.type == SectionType.RESULTS_PAGE && this.navigation.back()
        this.currentNavigation.goToStep(stepIndex);
    }

    @Emit('navigation-allowed')
    onNavigationAllowed() {}


    get rootElementClass(): string {
        return "page-selector-wrapper";
    }

    get shouldShowHeadline() {
        return this.showHeadline;
    }

    get shouldShowPageNumbers() {
        return !this.shouldShowHeadline;
    }

    get shouldShowQuestionPurpose () {
        return this.componentConfiguration.showQuestionPurpose == true && !this.shouldShowHeadline;
    }


    get currentNavigation() {
        return this.navigation.sections.find(section => section.type === 'QUESTIONNAIRE').navigation as QAFlowStepsNavigation
    }
}
